import OrchidProAvatar from "components/orchid-pro-avatar";
import AvailabilityTag from "components/orchid-pro/availability-tag/AvailabilityTag";
import { HTMLProps, useCallback, useMemo } from "react";
import { AmplitudePageName, track } from "utils/amplitude";
import {
  getOrchidProCertificationString,
  getOrchidProNameAndAllGraduateDegreesString,
  getOrchidProTypeStringFromNewArr,
} from "utils/formatter/orchidPro";
import styles from "./OrchidProCardMobile.module.scss";
import getClasses from "utils/getClasses";
// import AppointmentBook from "components/AppointmentBook/AppointmentBook";

const AMPLITUDE_COMPONENT_NAME = "pro-card";

type Props = {
  orchidPro: OrchidPro;
  amplitudePageName?: AmplitudePageName;
} & HTMLProps<HTMLDivElement>;

const OrchidProCardMobile = ({ orchidPro, amplitudePageName }: Props) => {
  const shouldShowAvailabilityTag = useMemo(
    () => orchidPro.can_accept_payment,
    [orchidPro.can_accept_payment],
  );

  const trackLinkClick = useCallback(() => {
    if (!amplitudePageName) {
      return;
    }
    track(amplitudePageName, AMPLITUDE_COMPONENT_NAME, "click");
  }, [amplitudePageName]);

  return (
    <div className={styles["container"]}>
      {shouldShowAvailabilityTag && (
        <AvailabilityTag
          orchid_pro_cognito_sub={orchidPro.cognito_sub}
          className={styles["availability-tag"]}
          highlightToday={false}
        />
      )}
      <a
        className={getClasses(
          styles["personal-info"],
          styles["no-link-decoration"],
        )}
        href={`/professional-search/${orchidPro.custom_url}`}
        onClick={trackLinkClick}
      >
        <OrchidProAvatar orchidPro={orchidPro} />
        <div className={styles["bio"]}>
          <div className={styles["name"]}>
            {getOrchidProNameAndAllGraduateDegreesString(orchidPro)}
          </div>
          <div>
            <div className={styles["type"]}>
              {orchidPro.cognito_sub ===
              "9929e6ac-8d68-4fba-8208-9b14ec05f132" ? (
                <p className="rg-14 gray01 mb-0">
                  Licensed Occupational Therapist
                </p>
              ) : (
                getOrchidProTypeStringFromNewArr(orchidPro)
              )}
            </div>
            <div className={styles["certification"]}>
              {getOrchidProCertificationString(orchidPro)}
            </div>
          </div>
        </div>
      </a>
      {/* <AppointmentBook
        orchidPro={orchidPro}
        amplitudePageName={amplitudePageName}
        amplitudeComponentName={AMPLITUDE_COMPONENT_NAME}
      /> */}
    </div>
  );
};

export default OrchidProCardMobile;
